import React from 'react';
import PricingOptionsList from './PricingOptionsList';
import PricingComparisonTable from './PricingComparisonTable';
import Link from 'next/link';
import {Typography} from './ui/typography';
import {Button} from './ui/button';
import TextParser from './TextParser';
import {cn} from '../lib/utils';
import {Card, CardDescription, CardFooter, CardHeader, CardTitle} from './ui/card';

export default function PricingSection ({title, comparisonTable, description, plans, onSelect}) {
    return <div>
        <header className="pb-8">
            <Typography variant="h1">
                <TextParser text={title} />
            </Typography>
            <Typography>
                {description}
            </Typography>
        </header>
        
        <div className="flex justify-center items-center">
            <Typography>
                During the initial <strong>free 14-day</strong> trial with the Challenger functionality you can choose one of the below membership plans.
            </Typography>
        </div>

        <div className="p-12">
            <PricingOptionsList items={plans.map(p => {
                return {
                    ...p,
                    features: p.features.filter(f => f.enabled && f.level === 100)
                }
            })} onSelect={onSelect} />
        </div>

        <div className="flex justify-center items-center mb-6">
            <Typography>
                <Link href="/contact" passHref>
                    <a className="link-primary">Contact us</a>
                </Link>
                {' '}
                to get a corporate offer
            </Typography>
        </div>

        <Typography variant="h2" className="mb-6">
            Compare features
        </Typography>
        <PricingComparisonTable plans={plans} table={comparisonTable} onSelect={onSelect} />

        <div className="flex justify-center mt-12">
            <Card className={cn('border-0 bg-teal-100 relative')}>
                <CardHeader>
                    <CardTitle>
                        Still have a question?
                    </CardTitle>
                    <CardDescription>
                        If you have any questions, get in touch with us – we are happy to help you to choose the best plan for your needs.
                    </CardDescription>
                </CardHeader>
                <CardFooter>
                    <Link href={"/contact"} passHref>
                        <Button variant="outline" asChild>
                            <a>Ask a Question</a>
                        </Button>
                    </Link>
                </CardFooter>
            </Card>
        </div>
    </div>
}

